<template>
  <div class="dashboard-block">
    <form>
      <h2>Account Additional Details</h2>

      <div class="panel panel-grey">
        <div class="panel-body">
          <div class="form-horizontal">

            <div class="row">
              <div :class="hasErrorClass($v.user.custom_fields[index].value, 'form-group col-xs-12 col-lg-12')" v-for="(field, index) in user.custom_fields" :key="field.name">
                <!-- if its a URL field, use link at the label, and field name as the link-->
                <label class="control-label col-xs-2 col-lg-2" v-if="field.dataType ==='url'">URL Link</label>
                <label class="control-label col-xs-2 col-lg-2" v-else>{{field.name}}</label>
                <div class="col-xs-10 col-lg-10" v-if="field.dataType === 'text' || field.dataType === undefined">
                  <input
                    type="text"
                    class="form-control"
                    v-model="$v.user.custom_fields[index].value.$model"
                    maxlength="1024"/>
                </div>
                <div class="col-xs-10 col-lg-10" v-if="field.dataType === 'url'">
                  <div class="alert alert-primary"> <a :href="field.name" target="_blank">{{ field.name }}</a></div>
                </div>
                <div class="col-xs-10 col-lg-10" v-if="field.dataType === 'file'">
                  <file-input v-model="$v.user.custom_fields[index].value.$model" :prefix="'user-custom-fields'"/>
                </div>
                <div class="col-xs-10 col-lg-10" v-else-if="field.dataType === 'date'">
                  <div class="calendar-group">
                    <flat-pickr
                      v-model="$v.user.custom_fields[index].value.$model"
                      :config="flatPickerSingleDateConfig"
                      class="form-control pickdate"
                      name="date"/>
                  </div>
                </div>
                <div class="col-xs-10 col-lg-10" v-else-if="field.dataType === 'dropdown'">
                  <selectize
                    class="selectize selectize-single w-full"
                    name="timezone"
                    v-model="$v.user.custom_fields[index].value.$model"
                    :options="getListOptions(field.listOptions)">
                  </selectize>
                </div>
                <vuelidate-help :field="$v.user.custom_fields[index].value" :label="field.name" />
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <ladda-button class="btn btn-sm btn-primary" type="submit" :click="handleUpdateDetails" :disabled="userIsAdmin && !canEditAdmin">Save Changes</ladda-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {stateMapper, helpers} from 'mixins/users'
import {forIn, each} from 'lodash'
import {notify} from 'utils'
import moment from 'moment'
import Selectize from '../ext/codium/CodiumSelectize'
import { required } from 'vuelidate/lib/validators'
import FlatPickr from 'vue-flatpickr-component'
import VuelidateHelp from '../misc/VuelidateHelp'
import FileInput from '../misc/FileInput'

export default {
  mixins: [stateMapper, helpers],
  computed: {
    ...mapState('user', ['user'])
  },
  components: {
    FileInput,
    Selectize,
    FlatPickr,
    VuelidateHelp
  },
  validations () {
    const validations = {
      user: {
        custom_fields: {
        }
      }
    }
    this.user.custom_fields.forEach((field, index) => {
      validations.user.custom_fields[index] = {
        value: {}
      }
      if (field.required) {
        validations.user.custom_fields[index].value = { required: required }
      }
    })
    return validations
  },

  methods: {
    ...mapActions('user', ['updateUser', 'updateUserCustomFields']),

    handleUpdateDetails () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }
      const payload = this.user.custom_fields
      return this.updateUserCustomFields({id: this.user.id, payload})
        .then(() => {
          notify.success('Successfully saved user custom fields.')
          this.errors.clear()
        })
        .catch((errors) => {
          if (errors.response && errors.response.status === 422) {
            forIn(errors.response.data.errors, (errors, key) => {
              each(errors, error => notify.error(error))
            })
          } else {
            notify.error('Sorry something has gone wrong, please try again.')
            throw errors
          }
        })
    },
    flatPickerSingleDateConfig () {
      var userDatePref = 'd/m/Y'
      if (this.$user.date_format_preference === 'month-first') {
        userDatePref = 'M-d-Y'
      }

      return {
        altInput: true,
        altFormat: userDatePref,
        dateFormat: 'Y-m-d',
        wrap: true,
        disable: [
          (date) => {
            if (this.$userIsAdmin) {
              return false
            }

            return moment(date).isBefore(moment().startOf('day'))
          }
        ]
      }
    },
    getListOptions (list) {
      let listOptionArray = list.split(',')
      return listOptionArray.map(item => {
        return {
          id: item,
          text: item
        }
      })
    },
    hasErrorClass (field, classes) {
      if (field) {
        return field.$error ? `${classes} has-error` : `${classes}`
      }
      return `${classes}`
    }
  }
}
</script>
